/**
 * Renders an account logo image or an initials placeholder.
 * Props: logoUrl (string|null), companyName (string), size (default 40), className
 */
export const CompanyLogo = ({ logoUrl, companyName = "", size = 40, className = "" }) => {
  const initials = companyName
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase())
    .join("") || "?";

  const resolvedUrl = logoUrl
    ? (logoUrl.startsWith("http") ? logoUrl : `${process.env.REACT_APP_BACKEND_URL}${logoUrl}`)
    : null;

  return (
    <div
      data-testid="company-logo"
      className={`inline-flex items-center justify-center overflow-hidden bg-[#002FA7] text-white font-heading font-black ${className}`}
      style={{ width: size, height: size, fontSize: size * 0.4 }}
    >
      {resolvedUrl ? (
        <img
          src={resolvedUrl}
          alt={companyName}
          className="w-full h-full object-contain bg-white"
          onError={(e) => { e.currentTarget.style.display = "none"; }}
        />
      ) : (
        <span>{initials}</span>
      )}
    </div>
  );
};
